import { createContext, useContext } from 'react';

export const RouterGoContext = createContext();
export const useRouterGoContext = () => useContext(RouterGoContext);
